// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka
 * Created: March 3, 2017
 *
 *//*!
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka
 * Created: March 3, 2017
 *
 *//*!
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka
 * Created: March 3, 2017
 *
 */.at-nav-item{align-items:center;border-right:1px solid rgba(255,255,255,.3);border-left:1px solid rgba(0,0,0,.2);color:#fff;cursor:pointer;display:flex;height:100%;margin-left:0;text-transform:uppercase;padding:0 2rem}.at-nav-item--selected{background:rgba(255,255,255,.25)}`, "",{"version":3,"sources":["webpack://./components/NavItem/style.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAAA,CAAA;;;;;;;;;;;;;;;;;;;;EAAA,CAAA;;;;;;;;;;;;;;;;;;;;EAAA,CAyBE,aACE,kBAAA,CACA,2CAAA,CACA,oCAAA,CACA,UAAA,CACA,cAAA,CACA,YAAA,CAEA,WAAA,CACA,aAAA,CACA,wBAAA,CAEA,cAAA,CAEA,uBACE,gCAAA","sourcesContent":["/*!\n *\n * Copyright 2018 Odysseus Data Services, inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n *  limitations under the License.\n *\n * Company: Odysseus Data Services, Inc.\n * Product Owner/Architecture: Gregory Klebanov\n * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka\n * Created: March 3, 2017\n *\n */\n\n@use 'styles/vars-and-mixins' as *;\n\n.#{$namespace} {\n  &nav-item {\n    align-items: center;\n    border-right: 1px solid rgba(255, 255, 255, 0.3);\n    border-left: 1px solid rgba(0, 0, 0, 0.2);\n    color: #fff;\n    cursor: pointer;\n    display: flex;\n    // font-weight: $font-weight-bold;\n    height: 100%;\n    margin-left: 0;\n    text-transform: uppercase;\n\n    padding: 0 2rem;\n\n    &--selected {\n      background: rgba(255, 255, 255, 0.25);\n    }\n\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
